import { render, staticRenderFns } from "./peekaboo.vue?vue&type=template&id=545df8cc"
import script from "./peekaboo.vue?vue&type=script&lang=js"
export * from "./peekaboo.vue?vue&type=script&lang=js"
import style0 from "./peekaboo.vue?vue&type=style&index=0&id=545df8cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports